import { api } from "@/services/api";
import { AppSettings, UpdateAppSettings } from "@/types";

export class AppSettingsRepository {
  async find(): Promise<AppSettings> {
    const response = await api.get("/v1/admin/app-settings");

    return response.data;
  }

  async update(data: UpdateAppSettings): Promise<AppSettings> {
    const response = await api.patch("/v1/admin/app-settings", data);

    return response.data;
  }
}
